export default {
    all: { method: 'GET', url: 'conta-pagar' },
    active: { method: 'GET', url: 'conta-pagar/active' },
    get: { method: 'GET', url: 'conta-pagar/get{/id}' },
    create: { method: 'POST', url: 'conta-pagar' },
    createConciliado: { method: 'POST', url: 'conta-pagar/recebimento' },
    update: { method: 'PUT', url: 'conta-pagar' },
    inactive: { method: 'DELETE', url: 'conta-pagar{/id}{/idMov}' },
};